import { SupXCircle } from "@repo/core-ui";
import { Networkish } from "@/types";
import useChainInfo from "@/hooks/useChainInfo";
import UiTooltip from "@/components/Ui/Tooltip";
import Image from "next/image";

import React, { Fragment } from "react";
import { SupChip, SupLoader } from "@repo/core-ui";
import { twMerge } from "tailwind-merge";

interface UiWidgetChainSelectorBadgeProps {
  chainId: Networkish;
  fluid?: boolean;
  className?: string;
  isSmall?: boolean;
  iconOnly?: boolean;
}

export default function UiWidgetChainSelectorBadge({ chainId, className = "w-fit", fluid = false, isSmall = false, iconOnly = false }: UiWidgetChainSelectorBadgeProps) {
  const { data, isLoading, isError, error } = useChainInfo(chainId);

  return isLoading ? (
    <SupLoader isSmall />
  ) : (
    <UiTooltip enable={isError} content={`${error}`}>
      <Fragment>
        <SupChip
          label={iconOnly ? "" : data ? data.name : "No chain data"}
          icon={
            data ? (
              <Image unoptimized={true} width={16} className="rounded-full bg-white object-fill object-center" height={16} src={data.icon} alt={data.name} />
            ) : (
              <SupXCircle className="text-warning-600" />
            )
          }
          iconType="rounded"
          small={isSmall}
          className={twMerge(className, fluid && "w-full")}
        />
      </Fragment>
    </UiTooltip>
  );
}
